import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgAisModule } from 'angular-instantsearch';
import { SearchbarComponent } from './searchbar.component';
import { SearchbarModalComponent } from './searchbar-modal/searchbar-modal.component';
import { SharedModule } from '@app/shared/shared.module';

import { MatDialogModule } from '@angular/material/dialog';
import { HelpersService } from '@app/shared/services/helpers/helpers.service';
import { SearchbarContentComponent } from './searchbar-content/searchbar-content.component';
import { WindowRefService } from '@app/shared/services/windowRef/window-ref.service';
import { SearchService } from '@app/shared/services/search/search.service';
import { AisClearRefinementsComponent } from '@app/shared/components/searchbar/ais-clear-refinements/ais-clear-refinements.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, NgAisModule, MatDialogModule, SharedModule, FormsModule],
  declarations: [SearchbarComponent, SearchbarModalComponent, SearchbarContentComponent, AisClearRefinementsComponent],
  exports: [SearchbarComponent, SearchbarModalComponent, SearchbarContentComponent],
  entryComponents: [SearchbarModalComponent, SearchbarContentComponent],
  providers: [HelpersService, WindowRefService, SearchService]
})
export class SearchbarModule {}
